import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./vuex/store";
import Vuex from "vuex";
import router from "./router/index";
import axios from "./utils/axios";
import dayjs from 'dayjs';
import "font-awesome/css/font-awesome.min.css";
// 导入supper组件（仅在main.js处理路由时需要）
import supper from "./views/nav1/supper.vue";
import VueRouter from "vue-router";

Vue.use(ElementUI);
Vue.use(Vuex);
Vue.prototype.$http = axios;
Vue.prototype.$dayjs = dayjs;

// 1. 获取supper权限（复用函数）
function getSupperPermission() {
  try {
    return parseInt(localStorage.getItem("supper") || "0", 10);
  } catch (e) {
    console.error("获取supper权限失败:", e);
    return 0;
  }
}

// 2. 初始化路由权限（仅执行一次，在守卫前完成）
function initSupperRoute() {
  const supperPermission = getSupperPermission();
  const orderRouteIndex = router.options.routes.findIndex(route => route.name === "订单");

  if (orderRouteIndex === -1) return;

  const orderRoute = { ...router.options.routes[orderRouteIndex] };
  // 有权限：添加路由
  if (supperPermission === 1) {
    const hasSupper = orderRoute.children.some(child => child.path === "/supper");
    if (!hasSupper) {
      orderRoute.children.push({
        path: "/supper",
        component: supper,
        name: "gateATM补单"
      });
    }
  }
  // 无权限：移除路由
  else {
    orderRoute.children = orderRoute.children.filter(child => child.path !== "/supper");
  }

  // 3. 更新路由配置（关键：用replaceRoutes替代reset matcher，避免状态错乱）
  // Vue Router 3.x 无replaceRoutes，用matcher重置但仅执行一次
  router.matcher = new VueRouter({ routes: router.options.routes }).matcher;
  // 重新添加更新后的订单路由
  router.addRoutes([orderRoute]);
}

// 4. 初始化路由权限（仅在main.js启动时执行一次）
initSupperRoute();

// 5. 修复路由守卫：简化逻辑，避免不必要的重定向
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // 未登录 → 跳登录页（仅拦截非登录页）
  if (!token && to.path !== "/login") {
    next({ path: "/login" });
    return;
  }

  // 已登录 → 根路径跳table（仅一次重定向）
  if (token && to.path === "/") {
    next({ path: "/table" });
    return;
  }

  // supper路由权限验证（已登录前提下）
  if (to.path === "/supper" && getSupperPermission() !== 1) {
    next({ path: "/404" });
    return;
  }

  // 所有情况都处理完，正常放行（避免遗漏next()）
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");